var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_c('ListTitle',{attrs:{"headerNmae":_vm.headerNmae,"headerNmaeCh":_vm.headerNmaeCh}})],1),_c('p',{staticClass:"hr"}),_c('iframe',{staticClass:"trend-container2",attrs:{"src":_vm.url,"scrolling":"auto","frameborder":"0","id":"iframe"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }